import React, { Component } from "react";
import { observer } from "mobx-react";
import { fn_salesEtcNextPage, fn_salesEtcPrevPage } from "function/FnBodySales";

@observer
class SalesEtcPagingBottomView extends Component {
    render() {

        const { rootStore } = this.props;
        const salesStore = rootStore.salesStore;

        return (
            <div className="paging sales">
                <button type="button" className="prev" disabled={salesStore.getSalesEtcPaging.sales_page_no === 1 ? "disabled" : ""}
                    onClick={(evnet) => fn_salesEtcPrevPage(rootStore)}
                ><span>이전 페이지</span></button>
                <p className="number">
                    <strong><span className="screen_out">현재 페이지</span>{salesStore.getSalesEtcPaging.sales_page_no} </strong>
                    /
                    <span className="screen_out">전체 페이지</span> {salesStore.getSalesEtcPaging.sales_max_page}
                </p>
                <button type="button" className="next" disabled={salesStore.getSalesEtcPaging.sales_page_no === salesStore.getSalesEtcPaging.sales_max_page ? "disabled" : ""}
                    onClick={(evnet) => fn_salesEtcNextPage(rootStore)}
                ><span>다음 페이지</span></button>
            </div>
        );
    }
}

export default SalesEtcPagingBottomView;